import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const sharedClassName = `relative inline-flex items-center justify-center font-[800] text-[18px] transition-all duration-250 rounded-[12px] overflow-hidden text-[#07090F] px-[40px] py-[22px] shadow-[0_0_40px_rgba(0,180,230,0.3)] hover:shadow-[0_0_60px_rgba(0,180,230,0.5)] ${fullWidth ? 'w-full' : ''} ${className}`;
  const sharedStyle = {
    background: 'linear-gradient(90deg, var(--accent), var(--accent-bright), var(--accent))',
    backgroundSize: '200% auto',
    animation: 'shimmer 3s linear infinite'
  } as const;
  const inner = <span className="relative z-10 flex items-center gap-2" data-id="element-288">{children}</span>;
  if (href) {
    return <motion.a href={href} whileHover={{
      scale: 1.02,
      filter: 'brightness(1.1)'
    }} whileTap={{
      scale: 0.98
    }} className={sharedClassName} style={sharedStyle} data-id="element-289">
        {inner}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02,
    filter: 'brightness(1.1)'
  }} whileTap={{
    scale: 0.98
  }} className={sharedClassName} style={sharedStyle} {...props} data-id="element-290">
      {inner}
    </motion.button>;
}